import React from "react";
import PropTypes from "prop-types";
import { connect, useSelector } from "react-redux";
import get from "lodash/get";
import { FbIcon } from "../atoms/icons/fb-icon";
import { TwitterIcon } from "../atoms/icons/twitter-icon";
import assetify from "@quintype/framework/assetify";
import whatsapp from "../../../assets/images/whatsapp.svg";
import Clipboard from "../../../assets/images/clipboard.svg";

import "./social-share-template.m.css";

const SocialShareTemplate = props => {
  const { member, fetchSubscription } = useSelector(state => state);
  const story = useSelector(state => get(state, ["qt", "data", "story"], null));

  const tags = story.sections.map(tag => tag.name).join(",");

  const pushToDataLayer = (event, platform) => {
    const obj = {
      event: event,
      content_name: story.headline,
      content_creator: story["author-name"],
      content_category: tags,
      platform: platform,
      usertype: member ? "logged in" : "logged out",
      subscribertype: fetchSubscription.isActive
        ? "subscriber"
        : "nonsubscriber",
      userID: member ? member.id : "null",
      subscriptionID: fetchSubscription.isActive
        ? fetchSubscription.items.find(sub => sub.active === true).id
        : "null"
    };

    window.dataLayer.push(obj);
  };

  const CopyText = () => {
    // document.execCommand("copy");
    const textArea = document.createElement("textarea");
    document.body.appendChild(textArea);
    textArea.value = props.fullUrl;
    textArea.select();
    document.execCommand("copy");
    document.body.removeChild(textArea);

    pushToDataLayer("article_share", "copylink");
    window.alert("Link copied");
  };

  return (
    <ul styleName="social-link-list">
      <li onClick={() => pushToDataLayer("article_share", "facebook")}>
        <a href={props.fbUrl} target="_blank" rel="noopener noreferrer">
          <FbIcon />
        </a>
      </li>
      <li onClick={() => pushToDataLayer("article_share", "twitter")}>
        <a href={props.twitterUrl} target="_blank" rel="noopener noreferrer">
          <TwitterIcon />
        </a>
      </li>
      <li onClick={() => pushToDataLayer("article_share", "whatsapp")}>
        <a href={props.whatsappUrl} target="_blank" rel="noopener noreferrer">
          <img src={assetify(whatsapp)} alt="whatsapp" />
        </a>
      </li>
      <li>
        <img
          style={{ cursor: "pointer" }}
          src={`${assetify(Clipboard)}`}
          alt="copy"
          onClick={() => CopyText()}
          title="Copy link"
        />
      </li>
    </ul>
  );
};

SocialShareTemplate.propTypes = {
  fbUrl: PropTypes.string,
  twitterUrl: PropTypes.string,
  whatsappUrl: PropTypes.string,
  fullUrl: PropTypes.string
};

const mapStateToProps = state => {
  return {
    currentHostUrl: get(state, ["qt", "currentHostUrl"], "")
  };
};

export default connect(mapStateToProps, null)(SocialShareTemplate);
